import {React,useReducer,useEffect} from 'react'
import {BestSelling} from './Fetcher'
import Product from './Product'
import Singlegadget from './Singlegadget'


const initaistate ={
 
  loading : true,
  data : [],
  error : '',

}


const reducer = (state,action)=>{
switch(action.type){
  case 'sucess' :
    return{...state,
      loading: false ,
      data: action.payload,
      error: ''
    }
case 'error' :
  return{...state,
    loading: false ,
    data: [],
    error: action.errormessage
  }
}
}



export const Bestselling = () => {

  const [ productdata , dispatch] = useReducer(reducer,initaistate)
  useEffect(()=>{
    BestSelling({dispatch:dispatch})
  },[])

    
  const rerenderproduct=()=>{
    return  productdata.data.map(data=>(
     <Singlegadget key={data.id} data={data}/>
    
    ))
  }
  return (
    <div>

 
   

 
  { productdata.loading ? 'loading': rerenderproduct()}  
{ productdata.error ? `Error ${ productdata.error}`  : null}




</div>
  )
}
